import { useState, useEffect } from 'react';
import OwnerPasswordDialog from './OwnerPasswordDialog';
import GenerateOwnerPasswordDialog from './GenerateOwnerPasswordDialog';
import { setRoundUnlockToken, setScoreEditUnlockToken } from '../lib/ownerAuth';

export default function OwnerGuardProvider() {
  const [open, setOpen] = useState(false);
  const [context, setContext] = useState(null);

  useEffect(() => {
    const handler = (e) => {
      setContext(e.detail || {});
      setOpen(true);
    };
    window.addEventListener('foretour:owner-required', handler);
    return () => window.removeEventListener('foretour:owner-required', handler);
  }, []);

  const handleSuccess = (token) => {
    if (context?.tripCode && context?.roundId) {
      if (context.reason === 'revealed_round') {
        setScoreEditUnlockToken(context.tripCode, context.roundId, token);
      } else {
        setRoundUnlockToken(context.tripCode, context.roundId, token);
      }
    }
    setOpen(false);
    setContext(null);
    window.dispatchEvent(new CustomEvent('foretour:owner-unlocked', { detail: { token } }));
  };

  const handleClose = (val) => {
    if (!val) {
      setOpen(false);
      setContext(null);
      window.dispatchEvent(new CustomEvent('foretour:owner-cancelled'));
    }
  };

  const isNotSet = context?.reason === 'not_set';

  if (isNotSet) {
    return (
      <GenerateOwnerPasswordDialog
        open={open}
        onOpenChange={handleClose}
        onSuccess={handleSuccess}
        tripCode={context?.tripCode}
      />
    );
  }

  const description = context?.reason === 'revealed_round'
    ? 'This round has been revealed. Master password is required to edit scores.'
    : 'Scores have been entered. Master password is required to make changes to this round.';

  return (
    <OwnerPasswordDialog
      open={open}
      onOpenChange={handleClose}
      onSuccess={handleSuccess}
      description={description}
      tripCode={context?.tripCode}
    />
  );
}
